import { Button } from '@mui/material';
import React from 'react';
import ProductsFormModal from './ProductsFormModal';
import { useCreateProductHandler } from '../dataHandlers/createProductHandler';

function ProductsListPageActions() {
  const [open, setOpen] = React.useState(false);

  const { onSubmit } = useCreateProductHandler();

  return (
    <>
      <Button id="add-product" key="add-new-product" variant="contained" color="primary" onClick={() => setOpen(true)}>
        + Add New
      </Button>
      <ProductsFormModal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        handleSubmit={onSubmit}
      />
    </>
  );
}

export default ProductsListPageActions;
